import React from "react";
import { BankStatementsProvider } from "../../components/BankStatements";
import { useAppSelector } from "../../redux/reduxHooks";

export const UnderwritingBankStatementsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const refreshStatementJobs = useAppSelector(
    (rootState) => rootState.underwriting.refreshStatementJobs
  );
  return (
    <BankStatementsProvider scheduleId={null} refreshSignal={refreshStatementJobs}>
      {children}
    </BankStatementsProvider>
  );
};
